import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Grid, Text } from '@chakra-ui/react';
import React from 'react';
import theme from '../../theme';
import { Select } from '../select/select';
import { defaultRowsPerPageOptions } from './rows-per-page-constants';
import { styles } from './rows-per-page.styles';
const RowsPerPage = (props)=>{
    const { pageSize, rowsPerPageOptions = defaultRowsPerPageOptions, handlePageSize, className } = props;
    const handleRowsPerPage = (event)=>{
        const target = event.currentTarget;
        handlePageSize(Number(target.value));
    };
    return /*#__PURE__*/ _jsxs(Grid, {
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        gridGap: theme.space[12],
        children: [
            /*#__PURE__*/ _jsx(Text, {
                textStyle: theme.textStyles['h1'],
                color: theme.colors.text['mediumEmphasis'],
                children: "Rows"
            }),
            /*#__PURE__*/ _jsx(Select, {
                items: rowsPerPageOptions,
                value: pageSize.toString(),
                dataTestId: "rowsPerPage",
                onChange: handleRowsPerPage,
                classes: {
                    button: className ?? styles.select
                }
            })
        ]
    });
};
RowsPerPage.displayName = 'RowsPerPage';
export { RowsPerPage };
